module.exports = __webpack_public_path__ + "static/pic03.1a5e9b90.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/pic03.jpg
// module id = 486
// module chunks = 114276838955818